import React, { useState } from "react";
import styled from "styled-components";
import {
  Box,
  ButtonStyled,
  DefaultProfileAvatar,
  HeadingStyled,
  TextStyled,
  ThemeLoader,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import TooltipInfo from "../../../../components/common/tooltip/InfoTooltip";
import CancelReqModal from "../../../../components/admin/Modals/CancelReqModal/CancelReqModal";
import { useNavigate } from "react-router-dom";
import { NoRecord } from "../../../../components/admin/NoRecord/NoRecord";

const PendingSentReqs = ({
  requests,
  acceptRejectRequest,
  isResolvingRequest,
  isLoading,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [requestId, setRequestId] = useState(null);


  return (
    <PendingSentWrapper>
      <div className="header">
        <HeadingStyled size="20px" color="var(--text)">
          {t("PendingSentRequests")}
        </HeadingStyled>
        <ButtonStyled
          size="14px"
          className="py-2"
          label={t("view_all")}
          onClick={() => navigate("/requests#sent_requests")}
        />
      </div>
      {isLoading ? (
        <ThemeLoader />
      ) : requests.length > 0 ? (
        <Box className="table-responsive">
          <table>
            <thead>
              <tr>
                <th>{t("benefactor")}</th>
                <th>{t("Requestedfor")}</th>
                <th>{t("Decision")}</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request, index) => (
                <tr key={index}>
                  <td>
                    <div className="requester-info">
                      {request.profilePic ? (
                        <img
                          src={request.profilePic}
                          alt={request.name}
                          className="profile-pic"
                        />
                      ) : (
                        <DefaultProfileAvatar
                          customClass="custom-avatar"
                          userDetail={{
                            first_name: request.name.split(" ")[0],
                            //   last_name: request.name.split(" ")[1] || "",
                          }}
                        />
                      )}
                      <div className="px-3">
                        <TextStyled
                          className="mb-0 text-nowrap"
                          size="14px"
                          color="var(--text)"
                          weight="500"
                        >
                          {request.name}
                        </TextStyled>
                        {request?.position ? (
                          <TextStyled
                            className="mb-0 text-nowrap"
                            size="12px"
                            color="var(--text2)"
                          >
                            {t(request.position)}
                          </TextStyled>
                        ) : (
                          <TextStyled
                            className="mb-0 text-nowrap"
                            size="12px"
                            color="var(--text2)"
                          >
                            {t(request.subLabel)}
                          </TextStyled>
                        )}
                      </div>
                    </div>
                  </td>
                  <td>
                    <Box className="d-flex align-items-center gap-2">
                      <TooltipInfo data={request.requestedFor.infoData} />
                      <TextStyled
                        className="mb-0"
                        size="14px"
                        color="var(--text)"
                      >
                        {t(request.requestedFor.module_type)}
                      </TextStyled>
                    </Box>
                  </td>
                  <td>
                    <Box className="d-flex">
                      <ButtonStyled
                        bg="var(--redColor)"
                        size="14px"
                        className="py-1 mx-2"
                        label={t("Cancel")}
                        onClick={() => {
                          setRequestId(request.id);
                          setShowCancelModal(true);
                        }}
                        isLoading={isResolvingRequest[`${request.id}-0`]}
                      />
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      ) : (
        <NoRecord />
      )}
      <CancelReqModal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        requestId={requestId}
        acceptRejectRequest={acceptRejectRequest}
      />
    </PendingSentWrapper>
  );
};

export default PendingSentReqs;

const PendingSentWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 1px solid var(--borderLight);
  }

  table {
    width: 100%;
    /* border-collapse: collapse; */

    th {
      text-align: start;
      padding: 12px 20px;
      color: var(--text);
      font-size: 14px;
      font-weight: 600;
      border-bottom: 1px solid var(--borderLight);
    }

    tr:not(:last-child) {
      border-bottom: 1px solid var(--borderLight);
    }

    td {
      padding: 12px 20px;
      vertical-align: middle;
    }
  }

  .requester-info {
    display: flex;
    align-items: center;
    gap: 5px;

    .profile-pic {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
`;
